/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrivateOrganizationDetails
 */
export interface PrivateOrganizationDetails {
    /**
     * 
     * @type {number}
     * @memberof PrivateOrganizationDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PrivateOrganizationDetails
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrivateOrganizationDetails
     */
    isPublic: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrivateOrganizationDetails
     */
    organizationCodes: Array<string>;
}

export function PrivateOrganizationDetailsFromJSON(json: any): PrivateOrganizationDetails {
    return PrivateOrganizationDetailsFromJSONTyped(json, false);
}

export function PrivateOrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateOrganizationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPublic': json['is-public'],
        'organizationCodes': json['organization-codes'],
    };
}

export function PrivateOrganizationDetailsToJSON(value?: PrivateOrganizationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is-public': value.isPublic,
        'organization-codes': value.organizationCodes,
    };
}


